// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file psypen/v1/session.proto (package psypen.v1, syntax proto3)
/* eslint-disable */

// The server's contract with its clients: what one session socket carries
// each way. It mirrors what /loop, /watch and /history/stream send as JSON
// today (server/internal/loop/handler.go), so the shapes can be retired one
// by one as the clients move over.

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file psypen/v1/session.proto.
 */
export const file_psypen_v1_session: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * Up is one message from the client to the server. On one socket per
 * session a turn is begun by a TurnStart and ended by its own end (or a
 * TurnCancel), not by opening and closing a connection.
 *
 * @generated from message psypen.v1.Up
 */
export type Up = Message<"psypen.v1.Up"> & {
  /**
   * @generated from oneof psypen.v1.Up.msg
   */
  msg: {
    /**
     * Audio is the microphone's speech, pcm_s16le mono, at 16 kHz unless
     * an AudioFormat said otherwise.
     *
     * @generated from field: bytes audio = 1;
     */
    value: Uint8Array;
    case: "audio";
  } | {
    /**
     * @generated from field: psypen.v1.AudioFormat audio_format = 2;
     */
    value: AudioFormat;
    case: "audioFormat";
  } | {
    /**
     * @generated from field: psypen.v1.Seam context = 3;
     */
    value: Seam;
    case: "context";
  } | {
    /**
     * @generated from field: psypen.v1.SpeechPause pause = 4;
     */
    value: SpeechPause;
    case: "pause";
  } | {
    /**
     * @generated from field: psypen.v1.SpeechOver over = 5;
     */
    value: SpeechOver;
    case: "over";
  } | {
    /**
     * @generated from field: psypen.v1.SpeechEnd end = 6;
     */
    value: SpeechEnd;
    case: "end";
  } | {
    /**
     * @generated from field: psypen.v1.TypedText text = 7;
     */
    value: TypedText;
    case: "text";
  } | {
    /**
     * @generated from field: psypen.v1.TurnStart turn_start = 8;
     */
    value: TurnStart;
    case: "turnStart";
  } | {
    /**
     * @generated from field: psypen.v1.TurnCancel turn_cancel = 9;
     */
    value: TurnCancel;
    case: "turnCancel";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message psypen.v1.Up.
 * Use `create(UpSchema)` to create a new message.
 */
export const UpSchema: GenMessage<Up> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 0);

/**
 * AudioFormat says the frames that follow are at this rate: the
 * microphone's own. Sent before the first frame, in any mode.
 *
 * @generated from message psypen.v1.AudioFormat
 */
export type AudioFormat = Message<"psypen.v1.AudioFormat"> & {
  /**
   * @generated from field: int32 rate = 1;
   */
  rate: number;
};

/**
 * Describes the message psypen.v1.AudioFormat.
 * Use `create(AudioFormatSchema)` to create a new message.
 */
export const AudioFormatSchema: GenMessage<AudioFormat> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 1);

/**
 * SpeechPause is the client's voice gate shut: the audio sent so far is a
 * whole piece of speech.
 *
 * @generated from message psypen.v1.SpeechPause
 */
export type SpeechPause = Message<"psypen.v1.SpeechPause"> & {
};

/**
 * Describes the message psypen.v1.SpeechPause.
 * Use `create(SpeechPauseSchema)` to create a new message.
 */
export const SpeechPauseSchema: GenMessage<SpeechPause> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 2);

/**
 * SpeechOver is the silence after a pause that lasted: the speaker has
 * finished.
 *
 * @generated from message psypen.v1.SpeechOver
 */
export type SpeechOver = Message<"psypen.v1.SpeechOver"> & {
};

/**
 * Describes the message psypen.v1.SpeechOver.
 * Use `create(SpeechOverSchema)` to create a new message.
 */
export const SpeechOverSchema: GenMessage<SpeechOver> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 3);

/**
 * SpeechEnd is no more audio: the user ended the utterance by hand (a
 * second press).
 *
 * @generated from message psypen.v1.SpeechEnd
 */
export type SpeechEnd = Message<"psypen.v1.SpeechEnd"> & {
};

/**
 * Describes the message psypen.v1.SpeechEnd.
 * Use `create(SpeechEndSchema)` to create a new message.
 */
export const SpeechEndSchema: GenMessage<SpeechEnd> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 4);

/**
 * TypedText is typed input instead of speech.
 *
 * @generated from message psypen.v1.TypedText
 */
export type TypedText = Message<"psypen.v1.TypedText"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;
};

/**
 * Describes the message psypen.v1.TypedText.
 * Use `create(TypedTextSchema)` to create a new message.
 */
export const TypedTextSchema: GenMessage<TypedText> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 5);

/**
 * TurnStart begins a turn, carrying what /loop takes as query parameters
 * today. The context (the seam) follows it, before any audio. The client's
 * version and OS are not here: they come from the /session query (`ver`,
 * `os`), once per socket, as agreed across the slices.
 *
 * @generated from message psypen.v1.TurnStart
 */
export type TurnStart = Message<"psypen.v1.TurnStart"> & {
  /**
   * Turn is the turn's id, minted by the client and unique per user: every
   * Down of this turn carries it, and a TurnCancel names it.
   *
   * @generated from field: string turn = 1;
   */
  turn: string;

  /**
   * @generated from field: psypen.v1.TurnMode mode = 2;
   */
  mode: TurnMode;

  /**
   * NoteId names the note a NOTE turn writes into (internal/note).
   *
   * @generated from field: string note_id = 3;
   */
  noteId: string;

  /**
   * MeetingId is the meeting a MEETING turn goes on with, when the client
   * dials again after a dropped connection; empty starts a new one.
   *
   * @generated from field: string meeting_id = 4;
   */
  meetingId: string;

  /**
   * Held is the mode the user held when they clicked the ball, for the
   * FEEDBACK turn's issue. It is read only on a FEEDBACK turn, and
   * UNSPECIFIED there means nothing was held.
   *
   * @generated from field: psypen.v1.TurnMode held = 5;
   */
  held: TurnMode;
};

/**
 * Describes the message psypen.v1.TurnStart.
 * Use `create(TurnStartSchema)` to create a new message.
 */
export const TurnStartSchema: GenMessage<TurnStart> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 6);

/**
 * TurnCancel cancels the turn it names (barge-in, D12): closing the socket
 * no longer does, since the socket outlives the turn.
 *
 * @generated from message psypen.v1.TurnCancel
 */
export type TurnCancel = Message<"psypen.v1.TurnCancel"> & {
  /**
   * @generated from field: string turn = 1;
   */
  turn: string;
};

/**
 * Describes the message psypen.v1.TurnCancel.
 * Use `create(TurnCancelSchema)` to create a new message.
 */
export const TurnCancelSchema: GenMessage<TurnCancel> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 7);

/**
 * Seam is the context the client attaches to a turn (D9): what it reads
 * around the user. Fields it cannot read on its platform are empty.
 *
 * @generated from message psypen.v1.Seam
 */
export type Seam = Message<"psypen.v1.Seam"> & {
  /**
   * Clipboard is the current selection or clipboard, whole.
   *
   * @generated from field: string clipboard = 1;
   */
  clipboard: string;

  /**
   * App and title identify the focused window.
   *
   * @generated from field: string app = 2;
   */
  app: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * Field is the focused field's kind and style the paragraph style at the
   * caret, where the platform exposes them.
   *
   * @generated from field: string field = 4;
   */
  field: string;

  /**
   * @generated from field: string style = 5;
   */
  style: string;

  /**
   * Gate: the client shows the confirmation gate. One that does not say so
   * gets no outbound tools (D6).
   *
   * @generated from field: bool gate = 6;
   */
  gate: boolean;

  /**
   * Zone is the user's IANA time zone ("Europe/Helsinki"); empty is the
   * server's own.
   *
   * @generated from field: string zone = 7;
   */
  zone: string;
};

/**
 * Describes the message psypen.v1.Seam.
 * Use `create(SeamSchema)` to create a new message.
 */
export const SeamSchema: GenMessage<Seam> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 8);

/**
 * Down is one message from the server to the client: a turn's output, the
 * standing socket's news, the snapshot it opens with and the deltas after.
 *
 * @generated from message psypen.v1.Down
 */
export type Down = Message<"psypen.v1.Down"> & {
  /**
   * Turn is the TurnStart's id on every message of that turn; empty on the
   * snapshot, the deltas and the news that belongs to no turn (a task's
   * state, the lines, a file).
   *
   * @generated from field: string turn = 17;
   */
  turn: string;

  /**
   * @generated from oneof psypen.v1.Down.msg
   */
  msg: {
    /**
     * @generated from field: psypen.v1.Transcript transcript = 1;
     */
    value: Transcript;
    case: "transcript";
  } | {
    /**
     * @generated from field: psypen.v1.Endpoint endpoint = 2;
     */
    value: Endpoint;
    case: "endpoint";
  } | {
    /**
     * @generated from field: psypen.v1.Reply reply = 3;
     */
    value: Reply;
    case: "reply";
  } | {
    /**
     * Audio is the reply's speech, pcm_s16le 24 kHz mono.
     *
     * @generated from field: bytes audio = 4;
     */
    value: Uint8Array;
    case: "audio";
  } | {
    /**
     * @generated from field: psypen.v1.Acting acting = 5;
     */
    value: Acting;
    case: "acting";
  } | {
    /**
     * @generated from field: psypen.v1.Insert insert = 6;
     */
    value: Insert;
    case: "insert";
  } | {
    /**
     * @generated from field: psypen.v1.Draft draft = 7;
     */
    value: Draft;
    case: "draft";
  } | {
    /**
     * @generated from field: psypen.v1.Needs needs = 8;
     */
    value: Needs;
    case: "needs";
  } | {
    /**
     * @generated from field: psypen.v1.TaskState task = 9;
     */
    value: TaskState;
    case: "task";
  } | {
    /**
     * @generated from field: psypen.v1.Lines lines = 10;
     */
    value: Lines;
    case: "lines";
  } | {
    /**
     * @generated from field: psypen.v1.TurnFinished finished = 11;
     */
    value: TurnFinished;
    case: "finished";
  } | {
    /**
     * @generated from field: psypen.v1.TurnError error = 12;
     */
    value: TurnError;
    case: "error";
  } | {
    /**
     * @generated from field: psypen.v1.Meeting meeting = 13;
     */
    value: Meeting;
    case: "meeting";
  } | {
    /**
     * @generated from field: psypen.v1.TaskFile file = 14;
     */
    value: TaskFile;
    case: "file";
  } | {
    /**
     * @generated from field: psypen.v1.Snapshot snapshot = 15;
     */
    value: Snapshot;
    case: "snapshot";
  } | {
    /**
     * @generated from field: psypen.v1.Delta delta = 16;
     */
    value: Delta;
    case: "delta";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message psypen.v1.Down.
 * Use `create(DownSchema)` to create a new message.
 */
export const DownSchema: GenMessage<Down> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 9);

/**
 * Transcript is what the recogniser heard: final is settled, interim may
 * still change.
 *
 * @generated from message psypen.v1.Transcript
 */
export type Transcript = Message<"psypen.v1.Transcript"> & {
  /**
   * @generated from field: string final = 1;
   */
  final: string;

  /**
   * @generated from field: string interim = 2;
   */
  interim: string;
};

/**
 * Describes the message psypen.v1.Transcript.
 * Use `create(TranscriptSchema)` to create a new message.
 */
export const TranscriptSchema: GenMessage<Transcript> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 10);

/**
 * Endpoint is the server ending the utterance: the recogniser's endpoint,
 * or a bound (nothing said, too long). The client stops the microphone.
 *
 * @generated from message psypen.v1.Endpoint
 */
export type Endpoint = Message<"psypen.v1.Endpoint"> & {
};

/**
 * Describes the message psypen.v1.Endpoint.
 * Use `create(EndpointSchema)` to create a new message.
 */
export const EndpointSchema: GenMessage<Endpoint> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 11);

/**
 * Reply is a piece of the reply, in order.
 *
 * @generated from message psypen.v1.Reply
 */
export type Reply = Message<"psypen.v1.Reply"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;
};

/**
 * Describes the message psypen.v1.Reply.
 * Use `create(ReplySchema)` to create a new message.
 */
export const ReplySchema: GenMessage<Reply> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 12);

/**
 * Acting is a tool call in flight; what is the client's line for it.
 *
 * @generated from message psypen.v1.Acting
 */
export type Acting = Message<"psypen.v1.Acting"> & {
  /**
   * @generated from field: string what = 1;
   */
  what: string;
};

/**
 * Describes the message psypen.v1.Acting.
 * Use `create(ActingSchema)` to create a new message.
 */
export const ActingSchema: GenMessage<Acting> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 13);

/**
 * Insert is text to type into the focused field.
 *
 * @generated from message psypen.v1.Insert
 */
export type Insert = Message<"psypen.v1.Insert"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;
};

/**
 * Describes the message psypen.v1.Insert.
 * Use `create(InsertSchema)` to create a new message.
 */
export const InsertSchema: GenMessage<Insert> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 14);

/**
 * Draft is the dictation so far, whole, for the client to show beside
 * itself. Each one replaces the last; nothing has been typed yet.
 *
 * @generated from message psypen.v1.Draft
 */
export type Draft = Message<"psypen.v1.Draft"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;
};

/**
 * Describes the message psypen.v1.Draft.
 * Use `create(DraftSchema)` to create a new message.
 */
export const DraftSchema: GenMessage<Draft> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 15);

/**
 * Needs is an outbound action waiting for the user's ok: the client holds
 * "needs you" with this line until it is answered (D6).
 *
 * @generated from message psypen.v1.Needs
 */
export type Needs = Message<"psypen.v1.Needs"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;
};

/**
 * Describes the message psypen.v1.Needs.
 * Use `create(NeedsSchema)` to create a new message.
 */
export const NeedsSchema: GenMessage<Needs> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 16);

/**
 * TaskState is where a task of the user stands, sent as it changes and as
 * a socket opens: "running" or "waiting" lights the pill, "idle" is none
 * running, and the lane's other notices (started, done, failed, cancelled)
 * pass through. Text is the line beside the pill; for "waiting" the hold's
 * one line (PRODUCT-102).
 *
 * @generated from message psypen.v1.TaskState
 */
export type TaskState = Message<"psypen.v1.TaskState"> & {
  /**
   * @generated from field: string state = 1;
   */
  state: string;

  /**
   * @generated from field: string text = 2;
   */
  text: string;
};

/**
 * Describes the message psypen.v1.TaskState.
 * Use `create(TaskStateSchema)` to create a new message.
 */
export const TaskStateSchema: GenMessage<TaskState> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 17);

/**
 * TurnFinished is the turn being over.
 *
 * @generated from message psypen.v1.TurnFinished
 */
export type TurnFinished = Message<"psypen.v1.TurnFinished"> & {
};

/**
 * Describes the message psypen.v1.TurnFinished.
 * Use `create(TurnFinishedSchema)` to create a new message.
 */
export const TurnFinishedSchema: GenMessage<TurnFinished> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 18);

/**
 * TurnError is the turn failing, with the words to show.
 *
 * @generated from message psypen.v1.TurnError
 */
export type TurnError = Message<"psypen.v1.TurnError"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message psypen.v1.TurnError.
 * Use `create(TurnErrorSchema)` to create a new message.
 */
export const TurnErrorSchema: GenMessage<TurnError> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 19);

/**
 * Meeting names the meeting this turn records, so a dropped client can
 * dial again with it (TurnStart.meeting_id).
 *
 * @generated from message psypen.v1.Meeting
 */
export type Meeting = Message<"psypen.v1.Meeting"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message psypen.v1.Meeting.
 * Use `create(MeetingSchema)` to create a new message.
 */
export const MeetingSchema: GenMessage<Meeting> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 20);

/**
 * TaskFile is a file a task of the user handed them, for the client to
 * save in Downloads. Size is the length of data.
 *
 * @generated from message psypen.v1.TaskFile
 */
export type TaskFile = Message<"psypen.v1.TaskFile"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: int64 size = 2;
   */
  size: bigint;

  /**
   * @generated from field: bytes data = 3;
   */
  data: Uint8Array;
};

/**
 * Describes the message psypen.v1.TaskFile.
 * Use `create(TaskFileSchema)` to create a new message.
 */
export const TaskFileSchema: GenMessage<TaskFile> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 21);

/**
 * Lines is the user's accounts as the client shows them, the whole list
 * each time; empty when there are none.
 *
 * @generated from message psypen.v1.Lines
 */
export type Lines = Message<"psypen.v1.Lines"> & {
  /**
   * @generated from field: repeated psypen.v1.Line lines = 1;
   */
  lines: Line[];
};

/**
 * Describes the message psypen.v1.Lines.
 * Use `create(LinesSchema)` to create a new message.
 */
export const LinesSchema: GenMessage<Lines> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 22);

/**
 * Line is an account as the front and the client show it (spec 03.2),
 * derived from its state and its worker.
 *
 * @generated from message psypen.v1.Line
 */
export type Line = Message<"psypen.v1.Line"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * Kind is "job" or "standing".
   *
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * Worker is "queued", "working", "holding", "idle", or empty for none.
   *
   * @generated from field: string worker = 4;
   */
  worker: string;

  /**
   * Need is the first need's words.
   *
   * @generated from field: string need = 5;
   */
  need: string;

  /**
   * NextFiring is the next firing of a trigger it is subscribed to; absent
   * until there is one.
   *
   * @generated from field: google.protobuf.Timestamp next_firing = 6;
   */
  nextFiring?: Timestamp | undefined;

  /**
   * @generated from field: int32 unread = 7;
   */
  unread: number;

  /**
   * @generated from field: repeated string open = 8;
   */
  open: string[];

  /**
   * @generated from field: repeated string done = 9;
   */
  done: string[];

  /**
   * @generated from field: string detail = 10;
   */
  detail: string;

  /**
   * @generated from field: repeated psypen.v1.Child children = 11;
   */
  children: Child[];

  /**
   * Last is the worker's latest mid-step line while one is on the account.
   *
   * @generated from field: string last = 12;
   */
  last: string;

  /**
   * Description is the one word for speech and the client's colour:
   * working, needs you, sleeping, failed, idle, done.
   *
   * @generated from field: string description = 13;
   */
  description: string;
};

/**
 * Describes the message psypen.v1.Line.
 * Use `create(LineSchema)` to create a new message.
 */
export const LineSchema: GenMessage<Line> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 23);

/**
 * Child is a PR or a link a machine session made.
 *
 * @generated from message psypen.v1.Child
 */
export type Child = Message<"psypen.v1.Child"> & {
  /**
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;
};

/**
 * Describes the message psypen.v1.Child.
 * Use `create(ChildSchema)` to create a new message.
 */
export const ChildSchema: GenMessage<Child> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 24);

/**
 * PendingAction is what waits at the gate: every call the one answer
 * resolves, the first of them first. Where it may be absent, absent is
 * "nothing waits".
 *
 * @generated from message psypen.v1.PendingAction
 */
export type PendingAction = Message<"psypen.v1.PendingAction"> & {
  /**
   * Id names what waits; an answer that carries it answers that and
   * nothing else.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Kind is "question" or "permission" for an item of the inbox, whose
   * first send's text is the item in full; empty for a send.
   *
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * @generated from field: repeated psypen.v1.PendingSend sends = 9;
   */
  sends: PendingSend[];

  /**
   * Line is the client's line for it.
   *
   * @generated from field: string line = 10;
   */
  line: string;

  /**
   * ExpiresAt is when it stops waiting; absent, it waits until it is
   * answered.
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 12;
   */
  expiresAt?: Timestamp | undefined;
};

/**
 * Describes the message psypen.v1.PendingAction.
 * Use `create(PendingActionSchema)` to create a new message.
 */
export const PendingActionSchema: GenMessage<PendingAction> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 25);

/**
 * PendingSend is one call waiting at the gate, in full.
 *
 * @generated from message psypen.v1.PendingSend
 */
export type PendingSend = Message<"psypen.v1.PendingSend"> & {
  /**
   * @generated from field: string tool = 1;
   */
  tool: string;

  /**
   * @generated from field: string target = 2;
   */
  target: string;

  /**
   * Lang is the language marker, ISO 639-1.
   *
   * @generated from field: string lang = 3;
   */
  lang: string;

  /**
   * Text is the whole draft, as it will be sent.
   *
   * @generated from field: string text = 4;
   */
  text: string;

  /**
   * @generated from field: string subject = 5;
   */
  subject: string;

  /**
   * Editable: the box may offer to rewrite the draft by hand.
   *
   * @generated from field: bool editable = 6;
   */
  editable: boolean;
};

/**
 * Describes the message psypen.v1.PendingSend.
 * Use `create(PendingSendSchema)` to create a new message.
 */
export const PendingSendSchema: GenMessage<PendingSend> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 26);

/**
 * HistoryEvent is one entry of what the user can look back at. Turn ties
 * the entries of one utterance together.
 *
 * @generated from message psypen.v1.HistoryEvent
 */
export type HistoryEvent = Message<"psypen.v1.HistoryEvent"> & {
  /**
   * Id is the stored row's id. 0 marks an event that is not stored (the
   * live-only kinds, acting and heard): a client does not dedupe it by id,
   * and does not take one replayed after a reconnect as current.
   *
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string turn = 2;
   */
  turn: string;

  /**
   * @generated from field: google.protobuf.Timestamp at = 3;
   */
  at?: Timestamp | undefined;

  /**
   * @generated from field: psypen.v1.HistoryKind kind = 4;
   */
  kind: HistoryKind;

  /**
   * @generated from field: string text = 5;
   */
  text: string;

  /**
   * @generated from field: string tool = 6;
   */
  tool: string;

  /**
   * Input is a tool call's input, as JSON text.
   *
   * @generated from field: string input = 7;
   */
  input: string;

  /**
   * @generated from field: bool error = 8;
   */
  error: boolean;
};

/**
 * Describes the message psypen.v1.HistoryEvent.
 * Use `create(HistoryEventSchema)` to create a new message.
 */
export const HistoryEventSchema: GenMessage<HistoryEvent> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 27);

/**
 * Note is one note of the record mode. Its id is minted by the client that
 * starts it and is unique per user.
 *
 * @generated from message psypen.v1.Note
 */
export type Note = Message<"psypen.v1.Note"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Source is "speech" for now.
   *
   * @generated from field: string source = 2;
   */
  source: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string text = 4;
   */
  text: string;

  /**
   * Raw is what the transcriber wrote, a block to a line, for a note that
   * was cleaned as it was spoken; empty for one without.
   *
   * @generated from field: string raw = 5;
   */
  raw: string;

  /**
   * @generated from field: google.protobuf.Timestamp started = 6;
   */
  started?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated = 7;
   */
  updated?: Timestamp | undefined;
};

/**
 * Describes the message psypen.v1.Note.
 * Use `create(NoteSchema)` to create a new message.
 */
export const NoteSchema: GenMessage<Note> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 28);

/**
 * ServiceStatus is one service on the connect page and the user's accounts
 * on it.
 *
 * @generated from message psypen.v1.ServiceStatus
 */
export type ServiceStatus = Message<"psypen.v1.ServiceStatus"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * Connected: at least one of its accounts is usable.
   *
   * @generated from field: bool connected = 3;
   */
  connected: boolean;

  /**
   * @generated from field: bool can_install = 4;
   */
  canInstall: boolean;

  /**
   * @generated from field: repeated psypen.v1.AccountStatus accounts = 5;
   */
  accounts: AccountStatus[];
};

/**
 * Describes the message psypen.v1.ServiceStatus.
 * Use `create(ServiceStatusSchema)` to create a new message.
 */
export const ServiceStatusSchema: GenMessage<ServiceStatus> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 29);

/**
 * AccountStatus is one stored account of a service.
 *
 * @generated from message psypen.v1.AccountStatus
 */
export type AccountStatus = Message<"psypen.v1.AccountStatus"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: bool connected = 3;
   */
  connected: boolean;

  /**
   * Reason is why a stored account is not usable: "broken" when its grant
   * stopped working, "permission" when it lacks what the plugin needs.
   *
   * @generated from field: string reason = 4;
   */
  reason: string;
};

/**
 * Describes the message psypen.v1.AccountStatus.
 * Use `create(AccountStatusSchema)` to create a new message.
 */
export const AccountStatusSchema: GenMessage<AccountStatus> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 30);

/**
 * Snapshot is the whole of what the client shows, sent as the session
 * socket opens; the Deltas after it are applied on top. A later Snapshot
 * can come mid-socket (the stream dropped events before they were read):
 * it replaces everything the client holds, and the Deltas after it apply
 * on top of it.
 *
 * @generated from message psypen.v1.Snapshot
 */
export type Snapshot = Message<"psypen.v1.Snapshot"> & {
  /**
   * Pending is the action waiting at the gate; absent when nothing waits.
   *
   * @generated from field: psypen.v1.PendingAction pending = 1;
   */
  pending?: PendingAction | undefined;

  /**
   * @generated from field: repeated psypen.v1.Line lines = 2;
   */
  lines: Line[];

  /**
   * History is the last rows, oldest first, as the deltas after it come.
   *
   * @generated from field: repeated psypen.v1.HistoryEvent history = 3;
   */
  history: HistoryEvent[];

  /**
   * @generated from field: repeated psypen.v1.Note notes = 4;
   */
  notes: Note[];

  /**
   * @generated from field: repeated psypen.v1.ServiceStatus connections = 5;
   */
  connections: ServiceStatus[];

  /**
   * Seq is the event stream's sequence the snapshot is current to.
   *
   * @generated from field: uint64 seq = 6;
   */
  seq: bigint;
};

/**
 * Describes the message psypen.v1.Snapshot.
 * Use `create(SnapshotSchema)` to create a new message.
 */
export const SnapshotSchema: GenMessage<Snapshot> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 31);

/**
 * Delta is one change after the snapshot. Seq is the stream sequence it was
 * stored under, so a client that reconnects asks for what came after the
 * last seq it applied (since=<seq>). Notes and connections are in the
 * snapshot only for now; their deltas are added to the oneof later.
 *
 * @generated from message psypen.v1.Delta
 */
export type Delta = Message<"psypen.v1.Delta"> & {
  /**
   * @generated from field: uint64 seq = 1;
   */
  seq: bigint;

  /**
   * @generated from oneof psypen.v1.Delta.change
   */
  change: {
    /**
     * @generated from field: psypen.v1.HistoryEvent history = 2;
     */
    value: HistoryEvent;
    case: "history";
  } | {
    /**
     * @generated from field: psypen.v1.Lines lines = 3;
     */
    value: Lines;
    case: "lines";
  } | {
    /**
     * @generated from field: psypen.v1.PendingChanged pending = 4;
     */
    value: PendingChanged;
    case: "pending";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message psypen.v1.Delta.
 * Use `create(DeltaSchema)` to create a new message.
 */
export const DeltaSchema: GenMessage<Delta> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 32);

/**
 * PendingChanged is the action at the gate changing: the new one, or none
 * when action is absent.
 *
 * @generated from message psypen.v1.PendingChanged
 */
export type PendingChanged = Message<"psypen.v1.PendingChanged"> & {
  /**
   * @generated from field: psypen.v1.PendingAction action = 1;
   */
  action?: PendingAction | undefined;
};

/**
 * Describes the message psypen.v1.PendingChanged.
 * Use `create(PendingChangedSchema)` to create a new message.
 */
export const PendingChangedSchema: GenMessage<PendingChanged> = /*@__PURE__*/
  messageDesc(file_psypen_v1_session, 33);

/**
 * TurnMode is what the user declared the utterance is for, held on the
 * client by its own key until they change it (D9).
 *
 * @generated from enum psypen.v1.TurnMode
 */
export enum TurnMode {
  /**
   * TURN_MODE_UNSPECIFIED is the conversation, as an orb from before the
   * modes that names none.
   *
   * @generated from enum value: TURN_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * TURN_MODE_CHAT is the conversation: the turn runs, the agent answers in
   * speech, and the server ends the utterance.
   *
   * @generated from enum value: TURN_MODE_CHAT = 1;
   */
  CHAT = 1,

  /**
   * TURN_MODE_DICTATE is the user's own words, cleaned and typed into the
   * focused field with no model turn behind them; only SpeechEnd ends it.
   *
   * @generated from enum value: TURN_MODE_DICTATE = 2;
   */
  DICTATE = 2,

  /**
   * TURN_MODE_NOTE writes the words into the note named by note_id and
   * nowhere else.
   *
   * @generated from enum value: TURN_MODE_NOTE = 3;
   */
  NOTE = 3,

  /**
   * TURN_MODE_FEEDBACK files one utterance as an issue (the development
   * team's only).
   *
   * @generated from enum value: TURN_MODE_FEEDBACK = 4;
   */
  FEEDBACK = 4,

  /**
   * TURN_MODE_MEETING records until it is ended (D35).
   *
   * @generated from enum value: TURN_MODE_MEETING = 5;
   */
  MEETING = 5,
}

/**
 * Describes the enum psypen.v1.TurnMode.
 */
export const TurnModeSchema: GenEnum<TurnMode> = /*@__PURE__*/
  enumDesc(file_psypen_v1_session, 0);

/**
 * HistoryKind is what one history entry is. ACTING and HEARD say what is
 * happening right now: they are streamed and never stored.
 *
 * @generated from enum psypen.v1.HistoryKind
 */
export enum HistoryKind {
  /**
   * @generated from enum value: HISTORY_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The user's utterance, as the cleanup left it.
   *
   * @generated from enum value: HISTORY_KIND_SAID = 1;
   */
  SAID = 1,

  /**
   * What was answered.
   *
   * @generated from enum value: HISTORY_KIND_REPLY = 2;
   */
  REPLY = 2,

  /**
   * One tool call: its input and what came back.
   *
   * @generated from enum value: HISTORY_KIND_TOOL = 3;
   */
  TOOL = 3,

  /**
   * Text typed into the focused field (dictation).
   *
   * @generated from enum value: HISTORY_KIND_INSERTED = 4;
   */
  INSERTED = 4,

  /**
   * Held at the gate for the user's answer (D6).
   *
   * @generated from enum value: HISTORY_KIND_NEEDS = 5;
   */
  NEEDS = 5,

  /**
   * The turn did not finish.
   *
   * @generated from enum value: HISTORY_KIND_FAILED = 6;
   */
  FAILED = 6,

  /**
   * Live only: a tool is running.
   *
   * @generated from enum value: HISTORY_KIND_ACTING = 7;
   */
  ACTING = 7,

  /**
   * Said into a note (the record mode).
   *
   * @generated from enum value: HISTORY_KIND_NOTED = 8;
   */
  NOTED = 8,

  /**
   * Live only: a note's block as it was transcribed, before its cleanup.
   *
   * @generated from enum value: HISTORY_KIND_HEARD = 9;
   */
  HEARD = 9,

  /**
   * A task's milestones: started, planned, done, failed, cancelled.
   *
   * @generated from enum value: HISTORY_KIND_TASK = 10;
   */
  TASK = 10,

  /**
   * A running task's progress line (stored as "note").
   *
   * @generated from enum value: HISTORY_KIND_PROGRESS = 11;
   */
  PROGRESS = 11,
}

/**
 * Describes the enum psypen.v1.HistoryKind.
 */
export const HistoryKindSchema: GenEnum<HistoryKind> = /*@__PURE__*/
  enumDesc(file_psypen_v1_session, 1);

